import { inject } from 'vue';
import { communityInjectionKey } from '../utils/keys';

export function useCommunity() {
  const name = inject(communityInjectionKey) as string;

  return {
    name,
  };
}
